import { appFields } from 'constants/appFields';

export const AppType = {
  accessor: appFields.APP_TYPE,
  footerSpan: 0,
  Header: 'Type',
  minWidth: 40,
};
